import React, { useEffect, useRef } from "react"
import styles from "./index.module.scss"
import lottie from 'lottie-web'

const LoadingCenter = ({
  msg = '加载中'
}) => {
  const lottieNode = useRef<any>(null)

  useEffect(() => {
    showLottie()
    return componentWillUnmount
  }, [])

  const componentWillUnmount = () => {
    lottie.destroy('loading-center')
  }

  const showLottie = () => {
    lottie.destroy('loading-center')
    import('./assets/loading.json').then((animationData) => {
      if (lottieNode.current) {
        lottie.loadAnimation({
          name: 'loading-center',
          container: lottieNode.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
        });
      }
    })
  }

  return (
    <div className={styles.loadingCenter}>
      <div className={styles.content}>
        <div className={styles.loadingCont} ref={item => { lottieNode.current = item }}></div>
        <div className={styles.msg}>{msg}</div>
      </div>
    </div>
  )
}

export default LoadingCenter